module.exports = __webpack_public_path__ + "static/c65001af025bda63f7c9b8b6c7767ebec7ed0f62dc85abf2d89763a8c411db9d-9e66a08a2cf9fd64bf7b75c45999d775.png";